import antdData from 'antd/lib/locale-provider/vi_VN'
// import localeData from 'react-intl/locale-data/vi'
// https://formatjs.io/docs/react-intl/upgrade-guide-3x/#migrate-to-using-native-intl-apis
import localeData from '@formatjs/intl-pluralrules/locale-data/vi'

require('@formatjs/intl-pluralrules/polyfill')
// require('@formatjs/intl-relativetimeformat/polyfill')
// require('@formatjs/intl-relativetimeformat/locale-data/vi')

const messages = {
  'backend.error.validator.usernameExist': 'Username đã được đăng ký',
  'backend.error.validator.emailExist': 'Email đã được đăng ký',
  'backend.error.validator.emailRequired': 'Email không thể rỗng',
  'backend.error.validator.accountNotFound': 'Không tìm thấy tài khoản',
  'backend.error.validator.noValidAccountFound': 'Không tìm thấy tài khoản hợp lệ',
  'backend.error.validator.accountIsInactive': 'Tài khoản chưa được kích hoạt',
  'backend.error.validator.accountIsBanned': 'Tài khoản đã bị khoá',
  'backend.error.validator.accountHadBeenActivated': 'Tài khoản đã được kích hoạt',
  'backend.error.validator.invalidLoginCredentials': 'Thông tin định danh không đúng',
  'backend.error.validator.emailUnmatched': 'Email khác với tài khoản liên kết',
  'backend.error.validator.invalidOldPassword': 'Mật khẩu cũ không hợp lệ',
  'backend.error.validator.activateTokenExpired': 'Mã xác thực đã hết hạn',
  'backend.error.validator.activateTokenInvalid': 'Mã xác thực không hợp lệ',
  'backend.error.validator.notHuman': 'Bạn không phải là người dùng bình thường đúng không?',
  'backend.error.validator.humanCheckingFailed': 'Yêu cầu kiểm tra bảo mật thất bại',
  'consent.v2.title': 'Tôi xác nhận đã đọc và đồng ý:',
  'consent.v2.required':
    '{tos} và cho phép VNG thu thập và xử lý dữ liệu cá nhân theo {privacy} cho mục đích quy định tại Mục II.2.1, 2.2, 2.3 {policy}.',
  'consent.v2.optional':
    'Cho phép VNG thu thập và xử lý dữ liệu cá nhân theo {privacy} cho mục đích quy định tại Mục II.2.4 {policy}.',
  'consent.tosLink': 'Điều khoản sử dụng dịch vụ',
  'consent.privacyLink': 'Chính sách bảo mật và bảo vệ dữ liệu cá nhân',
  'consent.policyLink': 'Chính sách',
  'consent.optionalTag': 'Không bắt buộc',
  'consent.modal.title': 'Cập nhật Điều khoản và Chính sách bảo mật',
  'consent.modal.description':
    'Code Tour vừa cập nhật Điều khoản sử dụng dịch vụ và Chính sách bảo mật và bảo vệ dữ liệu cá nhân. Bạn vui lòng xem lại các nội dung dưới đây và xác nhận lựa chọn của mình trước khi tiếp tục sử dụng Code Tour.',
  'consent.modal.submit': 'Xác nhận và tiếp tục',
  'consent.modal.logout': 'Đăng xuất',
  'consent.success.title': 'Đã cập nhật thành công!',
  'consent.success.description':
    'Cảm ơn bạn đã xác nhận Điều khoản sử dụng dịch vụ và Chính sách bảo mật và bảo vệ dữ liệu cá nhân.',
  'consent.success.continue': 'Tiếp tục',
  'backend.error.validator.consentRequired':
    'Bạn cần đồng ý Điều khoản sử dụng dịch vụ và Chính sách bảo mật để tiếp tục',
  'backend.error.validator.policyVersionChanged':
    'Điều khoản vừa được cập nhật, vui lòng xem lại và xác nhận',

  'notification.success.updateInfo': 'Cập nhật thông tin thành công',
  'notification.success.emailSent': 'Email đã được gửi thành công',
  'notification.success.send': 'Gửi thành công',
  'notification.success.save': 'Lưu thành công',

  'error.notFound': 'Không tìm thấy',
  'error.forbidden': 'Truy cập trái phép',

  'validator.required': 'Thông tin bắt buộc',
  'validator.noSpecialCharAllowed': 'Không chứa kí tự đặc biệt',
  'validator.textAtLeastNLength': 'Chiều dài tối thiểu là {N}',
  'validator.textMaxNLength': 'Chiều dài tối đa là {N}',
  'validator.invalidEmailFormat': 'Không đúng định dạng email',
  'validator.passwordUnmatched': 'Mật khẩu xác nhận không đúng',
  'validator.usernameOrEmailRequired': 'Vui lòng nhập Username hoặc Email',
  'validator.passwordRequired': 'Vui lòng nhập mật khẩu',
  'validator.passwordAtLeast1UpperCase': 'Mật khẩu phải chứa ít nhất 1 chữ hoa',
  'validator.passwordAtLeast1Number': 'Mật khẩu phải chứa ít nhất 1 chữ số',
  'validator.passwordAtLeast1SpecialChar': 'Mật khẩu phải chứ ít nhất một ký tự đặc biệt',
  'validator.passwordMayNotContainSequences':
    'Mật khẩu không được chứa các ký tự giống nhau liên tục',
  'validator.mustStartWith': 'Phải bắt đầu bằng {text}',
  'validator.svgPhotoBlocked': 'Định dạng hình ảnh SVG không được cho phép',
  'validator.alphabetOnly': 'Chỉ chấp nhận chữ cái',
  'validator.numericOnly': 'Chỉ chấp nhận chữ số',

  'button.save': 'Lưu',
  'button.cancel': 'Hủy',
  'button.edit': 'Sửa',
  'button.delete': 'Xoá',
  'button.joinNow': 'Tham gia Code Tour 2026',
  'button.createTeam': 'Tạo đội ngay',
  'button.add': 'Thêm mới',
  'button.addMember': 'Thêm thành viên',
  'button.invite': 'Mời',
  'button.getNewPassword': 'Lấy mật khẩu mới',
  'button.resend': 'Gửi lại',
  'button.preview': 'Xem trước',
  'button.savePost': 'Đăng bài',
  'button.comment': 'Bình luận',
  'button.viewMore': 'Xem thêm',
  'button.upload': 'Tải lên',
  'button.loginToComment': 'Đăng nhập để bình luận',
  'button.goBack': 'Về trang trước',
  'button.reply': 'Trả lời',
  'button.report': 'Báo cáo',
  'button.editOrDeleteThis': 'Chỉnh sửa hoặc xóa bình luận này',
  'button.here': 'Đây',
  'button.continue': 'Tiếp tục',
  'button.back': 'Quay lại',

  'misc.modal.confirmToDelete': 'Bạn có thực sự muốn xoá không?',
  'misc.noDataAvailable': 'Không có dữ liệu',
  'misc.requiredInformation': 'Bắt buộc',
  'misc.here': 'tại đây',

  'layout.header.home': 'Trang chủ',
  'layout.header.login': 'ĐĂNG NHẬP',
  'layout.header.logout': 'Đăng xuất',
  'layout.header.register': 'ĐĂNG KÝ',
  'layout.header.register_now': 'Đăng ký ngay',
  'layout.header.contest': 'Kỳ thi',
  'layout.header.training': 'Luyện thi',
  'layout.header.news': 'Tin tức',
  'layout.header.forum': 'Diễn đàn',
  'layout.header.ranking': 'Xếp hạng',
  'layout.header.manage_account': 'Quản lý tài khoản',
  'layout.header.my_profile': 'Hồ sơ của tôi',
  'layout.header.change_password': 'Đổi mật khẩu',
  'layout.header.manage_team': 'Quản lý đội',

  'layout.footer.links': 'Liên kết',
  'layout.footer.information': 'Thông tin chung',
  'layout.footer.about_us': 'Về Code Tour',
  'layout.footer.privacy': 'Chính sách bảo mật và bảo vệ dữ liệu cá nhân',
  'layout.footer.tos': 'Điều khoản sử dụng dịch vụ',
  'layout.footer.faq': 'Câu hỏi thường gặp',
  'layout.footer.copyright': 'Copyright © 2022',

  'layout.notification': 'Thông báo',
  'layout.notification.noData': 'Không có thông báo mới',
  'layout.notification.all': 'Tất cả',
  'layout.notification.unread': 'Chưa đọc',

  'auth.signIn': 'Đăng nhập',
  'auth.signUp': 'Đăng ký',
  'auth.activateSuccess': 'Kích hoạt tài khoản thành công',
  'auth.verificationRequired': 'Bạn chưa xác thực tài khoản',
  'auth.verificationGuideline':
    'Bạn vui lòng kiểm tra email và thực hiện theo hướng dẫn để xác thực email và hoàn thành đăng ký tài khoản trên Code Tour.',
  'auth.verificationGuidelineResend':
    'Nếu vẫn chưa nhận được email, bạn vui lòng nhấn vào {URL} để được gửi lại.',
  'auth.logout': 'Đăng xuất',
  'auth.email': 'Email',
  'auth.gender': 'Giới tính',
  'auth.gender_male': 'Nam',
  'auth.gender_female': 'Nữ',
  'auth.gender_other': 'Khác',
  'auth.username': 'Tên đăng nhập',
  'auth.username_note':
    'Vui lòng đặt username phù hợp, nghiêm túc và đúng quy chuẩn. BTC có quyền đổi hoặc hủy username không hợp lệ.',
  'auth.usernameOrEmail': 'Tên đăng nhập/Email',
  'auth.password': 'Mật khẩu',
  'auth.passwordConfirm': 'Xác nhận mật khẩu',
  'auth.socialSignIn': 'hoặc đăng nhập bằng',
  'auth.signIn.rememberMe': 'Duy trì đăng nhập',
  'auth.signIn.rememberMeHint': 'Duy trì đăng nhập để bạn không phải đăng nhập lại lần tiếp theo',
  'auth.signIn.forgotPassword': 'Quên mật khẩu?',
  'auth.signUp.createAccount': 'Tạo tài khoản',
  'auth.signUp.resendEmail': 'Gửi lại email',
  'auth.signUp.setupSocialAccount': 'Thiết lập tài khoản',
  'auth.signUp.agreeWith': 'Tôi đồng ý với',
  'auth.signUp.agreeWithTitle':
    'Bằng việc đăng ký tài khoản trên website codetour.org, bạn cho phép VNG sử dụng các thông tin cá nhân đã cung cấp cho các mục đích của cuộc thi.',

  'home.banner.platform': 'Nền tảng phát triển tư duy lập trình',
  'home.banner.platformDescription':
    'Cuộc thi <highlight>lập trình thi đấu</highlight> quy mô toàn quốc, nơi người trẻ <highlight>thử thách</highlight> tư duy thuật toán, <highlight>nâng cao</highlight> kỹ năng giải quyết vấn đề và <highlight>kết nối</highlight> cộng đồng công nghệ Việt Nam.',
  'home.banner.and': '',
  'home.banner.connection': 'kết nối cộng đồng yêu công nghệ',
  'home.banner.connection_1': 'kết nối đam mê',
  'home.banner.connection_2': 'phát triển cộng đồng',
  'home.banner.connection_3': 'công nghệ Việt Nam',
  'home.banner.connection_4': '',
  'home.banner.opportunity': 'mở ra cơ hội nghề nghiệp',
  'home.banner.opportunity_1': 'mở ra',
  'home.banner.opportunity_2': 'cơ hội nghề nghiệp',
  'home.introduction.title': 'Giới thiệu về Code Tour',
  'home.introduction.description':
    'Ra mắt từ năm 2018, Code Tour khởi đầu là sân chơi do VNG tổ chức, dành cho các bạn trẻ yêu thích thuật toán trên toàn quốc.\nĐến nay, Code Tour đã vươn mình trở thành nền tảng phát triển tư duy lập trình, gắn kết cộng đồng công nghệ và mở ra cơ hội nghề nghiệp cho thế hệ lập trình viên tương lai.',
  'home.fact.year': 'năm',
  'home.fact.ofDevelopment': 'hoạt động',
  'home.fact.participant': 'thí sinh tham gia',
  'home.fact.challenge': 'vòng thi',
  'home.fact.expert': 'chuyên gia',
  'home.glance.title': 'Code Tour 2026 có gì?',
  'home.glance.qualifierCount': '02',
  'home.glance.qualifier': 'Code Challenge',
  'home.glance.prizeCount': '100 triệu',
  'home.glance.prize': 'tổng giải thưởng',
  'home.glance.finalistCount': 'Top 50',
  'home.glance.finalist': 'vào Final Round',
  'home.glance.ageCount': '15-24',
  'home.glance.age': 'tuổi',
  'home.schedule.title': 'Thông tin Code Tour 2026',
  'home.benefit.challenge': 'Thử thách tư duy lập trình',
  'home.benefit.challengeDescription':
    'Chinh phục các bài toán do đội ngũ chuyên gia biên soạn, rèn luyện tư duy thuật toán và kỹ năng giải quyết vấn đề.',
  'home.benefit.prize': 'Chinh phục giải thưởng hấp dẫn',
  'home.benefit.prizeDescription':
    'Tranh tài với tổng giải thưởng hơn 100 triệu đồng, cùng nhiều quà tặng và quyền lợi dành TOP 50 thí sinh nổi bật.',
  'home.benefit.community': 'Kết nối cộng đồng công nghệ',
  'home.benefit.communityDescription':
    'Giao lưu, học hỏi và kết nối với những người trẻ yêu công nghệ trên toàn quốc trong cộng đồng Code Tour.',
  'home.benefit.growth': 'Rèn luyện kỹ năng dài hạn',
  'home.benefit.growthDescription':
    'Tiếp tục luyện tập trên nền tảng Code Tour sau mùa giải, nâng cao năng lực và sẵn sàng cho mùa giải tiếp theo.',
  'home.contest.title': 'Các cuộc thi nổi bật',
  'home.testimonial.title': 'Lời nhắn từ cựu thí sinh Code Tour',
  'home.partner.title': 'Đơn vị đồng hành',
  'home.partner.media': 'Đối tác truyền thông',
  'home.partner.organizer': 'Đơn vị tổ chức',
  'home.partner.coOrganizer': 'Đơn vị đồng tổ chức',
  'home.partner.partners': 'Đối tác',
  'home.partner.strategy': 'Đối tác chiến lược',
  'home.partner.companion': 'Đơn vị đồng hành',
  'home.partner.technical': 'Đối tác Kỹ thuật',
  'home.partner.academic': 'Đối tác Chuyên môn',
  'home.profileModal.title': 'Cập nhật thông tin',
  'home.profileModal.content':
    'Vui lòng cung cấp thêm thông tin tại mục "Quản lý tài khoản" để tham gia các kỳ thi',
  'home.profileModal.buttonText': 'Cập nhật ngay',

  'contest.searchPlaceholderPublic': 'Tìm tên cuộc thi',
  'contest.searchPlaceholderPrivate': 'Nhập mã chia sẻ',
  'contest.public': 'Công khai',
  'contest.private': 'Riêng tư',
  'contest.status.past': 'Đã diễn ra',
  'contest.status.onGoing': 'Đang diễn ra',
  'contest.status.planned': 'Sắp diễn ra',
  'contest.pleaseEnterSecretCode':
    'Bạn vui lòng nhập mã bí mật do Ban Tổ Chức cung cấp để tham gia Kỳ thi Riêng tư',
  'contest.noPrivateContestFound':
    'Cuộc thi bạn tìm kiếm không tồn tại, vui lòng nhập Mã chia sẻ khác',
  'contest.time': 'Thời gian',
  'contest.date': 'Ngày',
  'contest.begin': 'Bắt đầu',
  'contest.end': 'Kết thúc',
  'contest.venue': 'Địa điểm',
  'contest.viewDetail': 'Xem chi tiết',
  'contest.day': 'Ngày',
  'contest.day_short': 'd',
  'contest.hour': 'Giờ',
  'contest.hour_short': 'h',
  'contest.minute': 'Phút',
  'contest.minute_short': 'm',
  'contest.second': 'Giây',
  'contest.second_short': 's',
  'contest.registeredUser': 'Thí sinh đã đăng ký',
  'contest.scoreboard': 'Bảng xếp hạng',
  'contest.button.addToCalendar': 'Thêm vào lịch',
  'contest.button.addedToCalendar': 'Đã thêm lịch',
  'contest.button.register': 'Đăng ký thi',
  'contest.button.registered': 'Đã đăng ký',
  'contest.button.enterRoom': 'Vào phòng thi',
  'contest.page.information': 'Thông tin chung',
  'contest.page.waitingRoom': 'Phòng chờ',
  'contest.scoreboardAnnoucement':
    'Bảng xếp hạng chưa bao gồm kết quả rà soát video giám sát. Kết quả chính thức sẽ được công bố tại Fanpage {link}',
  'contest.scoreboard.name': 'Tên',
  'contest.scoreboard.score': 'Điểm',
  'contest.scoreboard.solved': 'Bài',
  'contest.scoreboard.penalty': 'Thời gian',
  'contest.scoreboard.penaltyHint':
    'Là tổng thời gian nộp bài của bạn, hiển thị theo định dạng ngày:giờ:phút:giây (nếu ngày bằng 0 thì số ngày sẽ bị bỏ)',
  'contest.scoreboard.firstToSolveProblem': 'Giải được đầu tiên',
  'contest.scoreboard.solvedProblem': 'Đã giải được',
  'contest.scoreboard.attemptedProblem': 'Chưa giải được',
  'contest.scoreboard.pendingProblem': 'Đang chấm',
  'contest.scoreBoardUpdating': 'Đang cập nhật',
  'contest.scoreBoardInReview': 'Đang chấm',
  'contest.scoreBoardFinalized': 'Đã kết thúc',
  'contest.judgementEnvironment': 'Môi trường chấm thi',
  'contest.judgementRanking': 'Tiêu chuẩn chấm bài',
  'contest.willBegin': 'Phòng thi sẽ bắt đầu sau',
  'contest.notLoggedInToAttendContest':
    'Bạn chưa đăng nhập. Vui lòng đăng nhập để đăng ký tham gia.',
  'contest.onlyRegisterOneContest': 'Chỉ được phép đăng ký một cuộc thi',
  'contest.notWhitelistedUser': 'Bạn không nằm trong danh sách được mời tham gia cuộc thi này',
  'contest.privateDomainRestricted': 'Bạn không đủ điều kiện tham gia cuộc thi riêng tư này',
  'contest.notInWhitelistedSchool':
    'Cuộc thi này chỉ dành cho thí sinh thuộc các trường được chỉ định',
  'contest.registrationNotOpen': 'Cuộc thi chưa mở đăng ký',
  'contest.facebookGroupModal':
    'Theo dõi Facebook Group Code to Connect để cập nhập thông tin mới nhất nhé!',
  'contest.vnoiGroupModal':
    'Cuộc thi sẽ diễn ra trên codetour.vnoi.info. Ban Tổ chức sẽ gửi tài khoản dự thi qua email trước 12 tiếng bắt đầu cuộc thi. Bạn hãy kiểm tra email để không bỏ sót thông tin quan trọng!',
  'contest.facebookGroupModalTitle': 'Bạn đã đăng ký dự thi thành công',
  'contest.scoreBoardFilterHelper': 'Tìm kiếm kết quả theo tên trường',

  'contest.unregister_modal.title': 'Xác nhận hủy đăng ký',
  'contest.unregister_modal.description':
    'Bạn có chắc chắn muốn hủy đăng ký khỏi kỳ thi này không?',
  'contest.unregister_modal.unregister': 'Có, hủy đăng ký',
  'contest.unregister_modal.cancel': 'Hủy bỏ',

  'news.writeComment': 'Viết bình luận',
  'news.writeReplyTo': 'Trả lời đến <username>',
  'news.filterTitle': 'Tin tức về #',

  'forum.title': 'Tiêu đề',
  'forum.searchPlaceholder': 'Tìm tên các chủ đề',
  'forum.recentPost': 'Bài đăng gần đây',
  'forum.post': 'Bài đăng',
  'forum.statistic': 'Thống kê',
  'forum.thread': 'Threads',
  'forum.message': 'Messages',
  'forum.createTopic': 'Tạo chủ đề',
  'forum.view': 'View',
  'forum.replies': 'Replies',
  'forum.reportContent': 'Báo cáo nội dung',
  'forum.reportReason': 'Lý do',

  'teamCard.pending': 'Chờ',
  'teamCard.leader': 'Trưởng nhóm',
  'teamCard.member': 'Thành viên',
  'teamCard.addMember': 'Thêm thành viên',
  'teamCard.invite': 'Mời',
  'teamCard.inviteSuccess': 'Đã gửi lời mời thành công.',
  'teamCard.myTeam': 'Đội của tôi',
  'teamCard.createTeam': 'Tạo đội',
  'teamCard.teamName': 'Tên đội',
  'teamCard.teamDescription': 'Mô tả về đội của bạn',
  'teamCard.confirmDelete': 'Xác nhận xoá',
  'teamCard.confirmDeleteMessage': 'Bạn có chắc chắn muốn xoá đối tượng này?',

  'profile.information': 'THÔNG TIN',
  'profile.challenges': 'Các cuộc thi tham gia',
  'profile.sum': 'Tổng điểm',
  'profile.forum': 'Diễn đàn',
  'profile.UserPractice': 'Luyện thi',
  'profile.resolvedAssignments': 'Danh sách bài tập đã giải',

  'aboutUs.aboutCodeTourTitle': 'Giới thiệu về Code Tour',
  'aboutUs.aboutCodeTourDescription':
    'Ra mắt từ năm 2018, Code Tour khởi đầu là sân chơi do VNG tổ chức, dành cho các bạn trẻ yêu thích thuật toán trên toàn quốc. Đến nay, Code Tour đã vươn mình trở thành nền tảng phát triển tư duy lập trình, gắn kết cộng đồng công nghệ và mở ra cơ hội nghề nghiệp cho thế hệ lập trình viên tương lai.',
  'aboutUs.infoVisionTitle': 'Tầm nhìn',
  'aboutUs.infoVisionDescription':
    'Code Tour mang đến nền tảng thân thiện với nhiều trải nghiệm thú vị để các lập trình viên vừa học hỏi vừa kết nối cùng nhau, tạo nên một cộng đồng công nghệ rộng lớn không chỉ ở Việt Nam còn hướng ra thị trường Đông Nam Á và quốc tế.',
  'aboutUs.infoSloganTitle': 'Slogan: Code. Connect. Challenge',
  'aboutUs.infoSloganDescription':
    '<bold>Code:</bold> Rèn luyện tư duy và kỹ năng lập trình.{endline}<bold>Connect:</bold> Giao lưu và kết nối cùng cộng đồng công nghệ.{endline}<bold>Challenge:</bold> Cọ xát thực tế để mở lối sự nghiệp.',
  'aboutUs.infoMissionTitle': 'Sứ mệnh: Phát triển tài năng công nghệ',
  'aboutUs.infoMissionDescription':
    'Mọi hoạt động và giá trị của Code Tour nhằm tạo điều kiện tốt nhất cho các Codee (tên gọi các thành viên của Code Tour) được nâng cao tư duy và phát triển kỹ năng bằng các kỳ thi, bài tập và mạng lưới kết nối với các nhân tài khác, giúp các bạn nuôi dưỡng đam mê và tích lũy năng lực để xây dựng sự nghiệp của mình.',
  'aboutUs.milestoneTitle': 'Các mùa Code Tour đã tổ chức',
  'aboutUs.milestoneBridgingTitle': 'Cầu nối',
  'aboutUs.milestoneBridgingDescription':
    'Năm 2025, Code Tour kết nối kiến thức học thuật với thực tiễn công nghệ, cùng sự đồng hành của doanh nghiệp, nhà trường và thế hệ trẻ yêu lập trình. Phối hợp tổ chức bởi VNG và ĐHQG-HCM, cuộc thi gồm 3 Code Challenge và 1 vòng Chung kết, thu hút 2.330 thí sinh đến từ 80 trường THPT, đại học trong và ngoài nước.',
  'aboutUs.milestoneInteractionTitle': 'Tương tác',
  'aboutUs.milestoneInteractionDescription':
    'Năm 2024, Code Tour thích ứng linh hoạt với 5 vòng thi Code Challenge trực tuyến kết hợp cùng 1 webinar tương tác, nơi thí sinh có thể lắng nghe chia sẻ lời giải và kinh nghiệm từ ban đề thi. Cuộc thi ghi nhận sự tham gia của hơn 1.500 coder trên khắp cả nước, tiếp tục khẳng định vị thế là sân chơi uy tín cho cộng đồng lập trình trẻ.',
  'aboutUs.milestoneConnectionTitle': 'Kết nối',
  'aboutUs.milestoneConnectionDescription':
    'Code Tour 2023 trở lại với hình thức thi offline tại 3 thành phố: Hà Nội, Đà Nẵng và TP.HCM, phối hợp cùng nhiều trường đại học đối tác. Vòng Chung kết diễn ra tại VNG Campus, quy tụ những thí sinh xuất sắc nhất. Toàn bộ mùa giải ghi nhận sự tham gia của 340 coder trên cả nước, mang đến bầu không khí sôi nổi và gắn kết cộng đồng sinh viên.',
  'aboutUs.milestoneExpansionTitle': 'Lan tỏa',
  'aboutUs.milestoneExpansionDescription':
    'Sau một năm gián đoạn để nâng cấp nền tảng, Code Tour 2022 trở lại đầy bùng nổ với 9 vòng thi Code Challenge trực tuyến toàn quốc và 2 vòng thi nội bộ VNG. Sự kiện hợp tác cùng Thành Đoàn TP.HCM và nhiều trường đại học lớn, thu hút hơn 2.500 coder, lập kỷ lục quy mô lớn nhất từ trước tới nay.',
  'aboutUs.milestoneCollaborationTitle': 'Hợp tác',
  'aboutUs.milestoneCollaborationDescription':
    'Code Tour 2020 đánh dấu bước ngoặt khi phối hợp cùng ĐH Bách khoa TP.HCM (HCMUT) và ĐH Công nghệ Thông tin (UIT) tổ chức vòng thi riêng cho sinh viên. Đồng thời, phiên bản đặc biệt Code Tour x VTF ra mắt để kết nối ứng viên chương trình VNG Tech Fresher, đưa tổng số thí sinh năm 2020 lên hơn 1.900 người.',
  'aboutUs.milestoneExpandTitle': 'Mở rộng',
  'aboutUs.milestoneExpandDescription':
    'Code Tour 2019 lần đầu tiên được tổ chức tại cả TP.HCM và Đà Nẵng, kết hợp nhiều hoạt động gắn kết cộng đồng ở các địa điểm mới lạ. Song song đó, cuộc thi có 5 vòng thi Code Challenge trực tuyến, nâng tổng số thí sinh tham gia trong năm lên hơn 1.600 người.',
  'aboutUs.milestoneBeginTitle': 'Khởi đầu',
  'aboutUs.milestoneBeginDescription':
    'Tiền thân của Code Tour là Saigon Code Tour 2018 - cuộc thi code dạo độc đáo do VNG tổ chức ở TP.HCM với 4 vòng thi Code Challenge, thu hút 182 thí sinh tham gia. Sự kiện mang tới một sân chơi học thuật mới mẻ và thú vị cho các bạn trẻ yêu thích lập trình.',

  'faq.faq': 'Câu hỏi thường gặp',

  'leaderBoard.title': 'Bảng xếp hạng',
  'leaderBoard.rank': 'Hạng',
  'leaderBoard.username': ' Tên đăng nhập',
  'leaderBoard.contest': 'Cuộc thi',
  'leaderBoard.contestHint': 'Code Challenges đã tham gia',
  'leaderBoard.averageScore': 'Điểm trung bình',
  'leaderBoard.averageScoreHint': 'Tổng điểm chia cho tổng số vòng thi chính thức đã tham gia',
  'leaderBoard.averagePenalty': 'Thời gian trung bình',
  'leaderBoard.averagePenaltyHint':
    'Tổng thời gian chia cho tổng số vòng thi chính thức đã tham gia',
  'leaderBoard.totalScore': 'Tổng điểm',
  'leaderBoard.totalScoreHint': 'Tổng điểm của các vòng thi chính thức đã tham gia',
  'leaderBoard.totalPenalty': 'Tổng thời gian',
  'leaderBoard.totalPenaltyHint': 'Tổng thời gian nộp bài của các vòng thi chính thức đã tham gia',
  'leaderBoard.searchPlaceholder': 'Nhập tên đăng nhập hoặc email',
  'leaderBoard.annual': 'Bảng xếp hạng theo năm',
  'leaderBoard.cumulative': 'Bảng xếp hạng tích luỹ',
  'leaderBoard.leaderBoardGuideline': 'Xem thông tin cơ chế BXH tại',
  'leaderBoard.leaderBoardCriteria': 'Cách tính bảng xếp hạng',

  'userProfile.manageAccount': 'Quản lý tài khoản',
  'userProfile.from': 'Từ',
  'userProfile.to': 'Đến',
  'userProfile.present': 'Hiện tại',
  'userProfile.changeUsername': 'Đổi tên',
  'userProfile.avatar.change': 'Đổi ảnh đại diện',
  'userProfile.avatar.uploadedPhotos': 'Ảnh đã tải lên',
  'userProfile.information': 'Thông tin cá nhân',
  'userProfile.informationShort': 'Thông tin',
  'userProfile.information.fullName': 'Họ và tên',
  'userProfile.information.gender': 'Giới tính',
  'userProfile.information.gender.male': 'Nam',
  'userProfile.information.gender.female': 'Nữ',
  'userProfile.information.gender.other': 'Khác',
  'userProfile.information.birthDate': 'Năm sinh',
  'userProfile.information.phone': 'Số điện thoại',
  'userProfile.information.email': 'Email',
  'userProfile.information.country': 'Quốc gia/Vùng lãnh thổ',
  'userProfile.information.province': 'Tỉnh/Thành phố',
  'userProfile.information.address': 'Địa chỉ',
  'userProfile.information.certificate': 'Tải giấy chứng nhận',
  'userProfile.education_experience': 'Kinh nghiệm và học vấn',
  'userProfile.education_experience.status': 'Tình trạng hiện tại',
  'userProfile.education_experience.student': 'Học sinh sinh viên',
  'userProfile.education_experience.worked': 'Người đi làm',
  'userProfile.education': 'Học vấn',
  'userProfile.education.longTitle': 'Trình độ học vấn',
  'userProfile.education.school': 'Trường',
  'userProfile.education.major': 'Chuyên ngành',
  'userProfile.education.majorHint': 'Vui lòng điền N/A nếu bạn không có chuyên ngành',
  'userProfile.education.current': 'Trường học hiện tại',
  'userProfile.education.other': 'Khác',
  'userProfile.education.otherHint': 'Nhập tên trường nếu bạn chọn Khác',
  'userProfile.education.code': 'Mã số sinh viên',
  'userProfile.education.codeHint': 'Nếu là học sinh nhập mã STUDENT',
  'userProfile.education.lock':
    'Tính năng cập nhập học vấn bị tạm khoá trong thời gian cuộc thi diễn ra',
  'userProfile.work': 'Kinh nghiệm',
  'userProfile.work.longTitle': 'Kinh nghiệm làm việc',
  'userProfile.work.title': 'Chức danh',
  'userProfile.work.company': 'Công ty',
  'userProfile.work.current': 'Công việc hiện tại',
  'userProfile.socialConnection': 'Liên kết tài khoản',
  'userProfile.socialConnectionShort': 'Liên kết',
  'userProfile.socialConnection.disconnect': 'Huỷ liên kết',
  'userProfile.changePassword': 'Đổi mật khẩu',
  'userProfile.changePasswordSuccess': 'Đổi mật khẩu thành công',
  'userProfile.changePassword.oldPassword': 'Mật khẩu cũ',
  'userProfile.changePassword.newPassword': 'Mật khẩu mới',
  'userProfile.changePassword.newPasswordConfirm': 'Xác nhận mật khẩu',
  'userProfile.changePassword.guideline.title': 'Làm theo các bước sau để thiết lập lại tài khoản:',
  'userProfile.changePassword.guideline.1': 'Nhập tên đăng nhập hoặc email',
  'userProfile.changePassword.guideline.2':
    'Chờ thông tin khôi phục được gửi đến địa chỉ email đã đăng kí trên Code Tour',
  'userProfile.changePassword.guideline.3': 'Làm theo hướng dẫn trong email',

  'myProfile.title': 'Hồ sơ',
  'myProfile.contest.participated': 'Cuộc thi tham gia',
  'myProfile.contest.all': 'Tất cả',
  'myProfile.contest.totalScore': 'Tổng điểm',
  'myProfile.forum.created': 'Đã tạo',
  'myProfile.forum.comment': 'Bình luận',
  'myProfile.forum.like': 'Yêu thích',

  'notification.action.reply': 'đã trả lời',
  'notification.action.post': 'đã có bài viết mới tới',
  'notification.action.like': 'đã thích',
  'notification.action.dislike': 'đã không thích',
  'notification.action.news': 'đã thêm',

  'notification.object.yourComment': 'bình luận của bạn',
  'notification.object.yourReply': 'bình luận của bạn',
  'notification.object.yourTopic': 'chủ đề của bạn',
  'notification.object.yourPost': 'bài viết của bạn',
  'notification.object.news': 'một bài viết',

  'UserPractice.col.name': 'Tên bài',
  'UserPractice.col.type': 'Phân loại',
  'UserPractice.col.level': 'Độ khó',
  'UserPractice.col.score': 'Điểm',
}

export default {
  locale: 'vi',
  antdData,
  localeData,
  messages,
}
